var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"document-container"},[_c('div',{staticClass:"login-container"},[_c('h2',[_vm._v("进入系统")]),_c('p',[_vm._v("登录后点击用户头像进入用户工作台，可查看积分余额、功能模块入口与使用记录。")]),_c('div',{staticClass:"imageInfo"},[_c('img',{attrs:{"src":require("@/assets/userBook/image22.png")}})])])])
}]

export { render, staticRenderFns }